import { render } from "./SingleSaleForNine.vue?vue&type=template&id=7f738b4c&scoped=true"
import script from "./SingleSaleForNine.vue?vue&type=script&lang=js"
export * from "./SingleSaleForNine.vue?vue&type=script&lang=js"

import "./SingleSaleForNine.vue?vue&type=style&index=0&id=7f738b4c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f738b4c"]])

export default __exports__